module.exports = __webpack_public_path__ + "static/media/skirting.75b2f799.svg";